import { PageHero, CtaSection } from '../../components'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import './Terms.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Điều khoản sử dụng' },
]

const TermsPage = () => {
  useDocumentTitle('Điều Khoản Sử Dụng - MAXCONST')

  return (
    <div className="terms-page">
      {/* Page Hero */}
      <PageHero
        tag="Quy định sử dụng"
        title="ĐIỀU KHOẢN SỬ DỤNG WEBSITE"
        titleHighlight="ĐIỀU KHOẢN"
        description="Chào mừng quý khách đến với website của MAXCONST. Vui lòng đọc kỹ các quy định sử dụng dịch vụ dưới đây."
        breadcrumbs={BREADCRUMBS}
      />

      <div className="container terms-container">
        <div className="terms-card">
          {/* Tóm tắt nội dung */}
          <div className="terms-intro-summary">
            <h3>Chào mừng quý khách đến với MAXCONST</h3>
            <p>
              Chào mừng quý khách đến với website chính thức của <strong>MAXCONST</strong> (Thương hiệu thành viên trực thuộc hệ sinh thái <strong>MAXHOME Group</strong>). Khi truy cập, duyệt thảo hoặc sử dụng website <strong>thietkethicongtrongoi.com</strong>, quý khách đồng ý tuân thủ và chịu sự ràng buộc bởi các điều khoản sử dụng dưới đây.
            </p>
          </div>

          {/* Mục 1 */}
          <div className="terms-section-detail">
            <h2 className="section-title-custom">1. Quyền sở hữu trí tuệ</h2>
            <p>
              Toàn bộ nội dung đăng tải trên website này bao gồm: các bản vẽ kiến trúc chi tiết, hình ảnh phối cảnh thiết kế 3D, hình ảnh chụp thực tế thi công tại công trường, bài viết thuyết minh, video dự án, logo thương hiệu và các tài liệu kỹ thuật khác đều thuộc quyền sở hữu trí tuệ hợp pháp của <strong>MAXCONST</strong> hoặc công ty mẹ <strong>MAXHOME Group</strong>.
            </p>
            <p>Chúng tôi nghiêm cấm mọi hành vi:</p>
            <ul className="custom-bullet-list">
              <li>Tự ý sao chép, tải về sử dụng hoặc phát tán hình ảnh công trình và bản vẽ của MAXCONST khi chưa có sự đồng ý bằng văn bản.</li>
              <li>Sử dụng các hình ảnh thiết kế của chúng tôi cho mục đích thương mại của cá nhân hoặc đơn vị kinh doanh khác để mạo danh uy tín thương hiệu.</li>
              <li>Chỉnh sửa, tẩy xóa logo hoặc thay đổi thông tin bản quyền trên các bản vẽ được MAXCONST công bố công khai.</li>
            </ul>
          </div>

          {/* Mục 2 */}
          <div className="terms-section-detail">
            <h2 className="section-title-custom">2. Giới hạn trách nhiệm về thông tin</h2>
            <ul className="custom-bullet-list">
              <li>Các phương án phối cảnh nhà đẹp, mặt bằng công năng và các bảng dự toán chi phí xây dựng sơ bộ đăng tải trên website mang tính chất tham khảo định hướng dịch vụ cho khách hàng.</li>
              <li>Phương án kiến trúc chính thức và chi phí thi công xây dựng trọn gói cuối cùng của mỗi công trình sẽ phụ thuộc hoàn toàn vào quá trình khảo sát thực tế khu đất, diện tích xây dựng, tuổi mệnh phong thủy của gia chủ, chủng loại vật tư lựa chọn và các điều khoản ràng buộc trong Hợp đồng thi công trọn gói được ký kết chính thức giữa hai bên.</li>
              <li>MAXCONST không chịu trách nhiệm pháp lý đối với bất kỳ sự tự ý áp dụng công thức tính toán hoặc bản vẽ tham khảo trên web vào thực tế xây dựng mà không có sự tư vấn chuyên môn từ kỹ sư hoặc kiến trúc sư của chúng tôi.</li>
            </ul>
          </div>

          {/* Mục 3 */}
          <div className="terms-section-detail">
            <h2 className="section-title-custom">3. Quy định gửi thông tin đăng ký tư vấn</h2>
            <p>
              Khi sử dụng các chức năng gửi yêu cầu tư vấn, dự toán vật tư hoặc liên hệ trên website, quý khách vui lòng cam kết:
            </p>
            <ul className="custom-bullet-list">
              <li>Cung cấp đầy đủ và chính xác các thông tin cơ bản bao gồm: Họ tên, Số điện thoại liên hệ và Email hoạt động.</li>
              <li>Nội dung yêu cầu phải nghiêm túc, liên quan trực tiếp đến dịch vụ thiết kế kiến trúc hoặc thi công nhà ở.</li>
              <li>Tuyệt đối không sử dụng thông tin liên lạc giả mạo, thông tin của người khác khi chưa được sự cho phép.</li>
              <li>Nghiêm cấm hành vi sử dụng hệ thống form liên hệ để gửi thư rác (spam), quảng cáo dịch vụ khác, hoặc đính kèm các tệp tin chứa mã độc hại.</li>
            </ul>
          </div>

          {/* Mục 4 */}
          <div className="terms-section-detail">
            <h2 className="section-title-custom">4. Thay đổi điều khoản và dịch vụ</h2>
            <p>
              <strong>MAXCONST</strong> có toàn quyền thay đổi, chỉnh sửa, thêm hoặc bớt bất kỳ điều khoản nào trong văn bản Điều khoản sử dụng này bất kỳ lúc nào mà không cần báo trước. Các thay đổi sẽ có hiệu lực ngay khi được đăng tải chính thức trên website. Việc tiếp tục sử dụng trang web sau khi các thay đổi được công bố đồng nghĩa với việc quý khách chấp thuận các điều khoản cập nhật đó.
            </p>
          </div>

          {/* Chân trang liên hệ */}
          <div className="terms-footer-contact">
            <h3>Kết nối ngay đến chúng tôi để được hỗ trợ MIỄN PHÍ nhanh chóng nhất:</h3>
            <p className="company-name">MAXCONST – Đơn vị thiết kế & thi công uy tín (Thành viên MAXHOME Group)</p>
            <div className="contact-details-grid">
              <a href="tel:0979808278" className="contact-card-mini-link">
                <div className="contact-card-mini">
                  <i className="fas fa-phone-alt" />
                  <div>
                    <span>Hotline tư vấn:</span>
                    <strong>0979.808.278</strong>
                  </div>
                </div>
              </a>
              <a href="https://thietkethicongtrongoi.com" target="_blank" rel="noopener noreferrer" className="contact-card-mini-link">
                <div className="contact-card-mini">
                  <i className="fas fa-globe" />
                  <div>
                    <span>Website chính thức:</span>
                    <strong>thietkethicongtrongoi.com</strong>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <CtaSection
        title="Đồng Hành Cùng MAXCONST Xây Dựng Ngôi Nhà Mơ Ước"
        titleHighlight="Đồng Hành Cùng MAXCONST"
        description="Liên hệ ngay với đội ngũ kiến trúc sư và chuyên gia phong thủy của chúng tôi để nhận báo giá chi tiết và phương án thiết kế tối ưu."
      />
    </div>
  )
}

export default TermsPage
